export default __webpack_public_path__ + "static/media/jewelry.505019f2.svg";